import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i-352781216__a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8M8 1.333A6.674 6.674 0 0 0 1.333 8 6.674 6.674 0 0 0 8 14.667 6.674 6.674 0 0 0 14.667 8 6.674 6.674 0 0 0 8 1.333m1.667 9.554a.666.666 0 0 0 .244-.911L8.667 7.821V4a.666.666 0 1 0-1.334 0v4c0 .117.031.232.09.333l1.333 2.31a.666.666 0 0 0 .91.244"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i-352781216__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "clock"}) } }